module.exports = __webpack_public_path__ + "media/images/icons/icon_bullet_green-a64a4342947f7623f1c8dcab8917e0f4.svg";